import { BASEURL } from "../../API/apiData";
import {bmcListsRoutes, bmcMainRoutes} from "./routes"

const getAllKeyPartners = async (projectID , bmcID) => {
  const token = localStorage.getItem("token");

    const requestOptions = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        },
    };
    const response = await fetch(
        `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.partners}`,
        requestOptions
      );
      const results = await response.json();
      return results;
}

const createNewKeyPartners = async (projectID, projectName, bmcID) => {
  const token = localStorage.getItem("token");

    const data = {
      key_partner_name: `${projectName} Key Partners`
    }
    const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
    const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.partners}`,
    requestOptions
    );
    const results = await response.json();
    return results;
} 

// === LIST ITEMS ===
const createNewKeyPartnersList = async (projectID, bmcID, channelID, name ) => {
  const token = localStorage.getItem("token");

  const data = {
    key_partner_item: {
      item_name: name
    }
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.partners}/${channelID}/${bmcListsRoutes.partnersItems}`,
    requestOptions
    );

const results = await response.json();
return results;

}

const editNewKeyPartnersList = async (projectID, bmcID, channelID, name, ID ) => {
  const token = localStorage.getItem("token");

const data = {
  key_partner_item: {
    item_name: name
  }
}

const requestOptions = {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(data),
};

const response = await fetch(
  `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.partners}/${channelID}/${bmcListsRoutes.partnersItems}/${ID}`,
  requestOptions
  );

const results = await response.json();
return results;

}

export { getAllKeyPartners , createNewKeyPartners, createNewKeyPartnersList, editNewKeyPartnersList }